import React from 'react';

import SectionIcon from '../SectionIcon/SectionIcon';
import styles from './panel-title.module.scss';

interface IPanelIconTitleProps {
  children: string;
}

export default function PanelIconTitle({ children }: IPanelIconTitleProps) {
  return (
    <div className={styles['ag-rightpanel-title']}>
      <SectionIcon />
      <span>{children}</span>
    </div>
  );
}
